import React, { Fragment } from 'react';
import { translate } from 'core/utils';
import { BaasicInput, BaasicDropdown, BaasicButton, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';

const MarkAsShippedTemplate = ({
	t,
	markAsShippedViewStore: {
		form,
		onKeyUp,
		onSwitch,
		isBulkAction,
		warehouseDropdownStore,
		carrierServiceDropdownStore,
		loading,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<ButtonGroup className="k-button-group--fullwidth spc--bottom--sml">
					<Button
						type="button"
						className="btn btn--sml"
						togglable={true}
						selected={form.$('isInternal').value}
						onClick={onSwitch}
						disabled={form.submitting}
					>
						{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.INTERNALSHIPMENT')}
					</Button>
					<Button
						type="button"
						className="btn btn--sml"
						togglable={true}
						selected={!form.$('isInternal').value}
						onClick={onSwitch}
						disabled={form.submitting}
					>
						{t('FULFILLMENTORDER.MARKASSHIPPEDMODAL.EXTERNALSHIPMENT')}
					</Button>
				</ButtonGroup>

				{form.$('isInternal').value && (
					<div className="inputgroup">
						{!isBulkAction && (
							<Fragment>
								<BaasicInput field={form.$('trackingNumber')} onKeyUp={e => onKeyUp(e, form.$('trackingNumber'))} />
								<BaasicInput field={form.$('cost')} onKeyUp={e => onKeyUp(e, form.$('cost'))} />
								<BaasicInput
									field={form.$('shippingCostSurcharge')}
									onKeyUp={e => onKeyUp(e, form.$('shippingCostSurcharge'))}
								/>
							</Fragment>
						)}
						<div className="spc--bottom--sml">
							<BaasicDropdown dropdownStore={warehouseDropdownStore} />
						</div>
						<div className="spc--bottom--sml">
							<BaasicDropdown dropdownStore={carrierServiceDropdownStore} />
						</div>
					</div>
				)}
				{form.error != null && <p className="type--color--warning">{translate(form.error)}</p>}
			</div>
			<div className="ReactModal__footer">
				<BaasicButton
					className="btn btn--med btn--primary spc--bottom--sml"
					type="submit"
					disabled={form.submitting}
					label="SAVE"
				/>
			</div>
		</form>
	);
};

export default defaultTemplate(MarkAsShippedTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/MarkAsShippedTemplate.jsx